'use strict';

// setInterval function id
let intervalId = null;

/**
 * Polling function on set interval. 
 *
 * @param fn The function to call.
 * @param repeatInterval The interval (in milliseconds) before calling the function again.
 */
exports.poll = (fn, repeatInterval) => {

    try {
        startPolling(fn, repeatInterval);

        return function () {

            clearInterval(intervalId);
        };
    }
    catch (e) {
        clearInterval(intervalId);
        throw e;
    }
};

const startPolling = async (fn, repeatInterval) => {

    await fn();
    // assign the setInterval function
    intervalId = setInterval(async () => {

        await fn();
    }, repeatInterval);
};
